
import { controls } from "../../controls"

const ms221 = {
  label: "Special Instruction",
  pageLabel: "Special Instruction",
  starting: true,
  formActions: { edit: { allow: true } },
  url: "ms221",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Create",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", widths: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", isRequired: true, name: "branch_display", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", isRequired: true, width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      tab: "create", beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ tab: "filter", data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.magicDateLabel({ tab: "filter", label: "From Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "form_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "to_date", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", label: "Number Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),

  ],
  form: [
    ...controls.displayText({ tab: "create", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-5" }),

    ...controls.displayText({ tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: 'create', isReadOnly: 'edit', isRequired: true, }),
    ...controls.showData({ tab: "create", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-6" }),
    ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      tab: "create", beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ tab: "create", data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "create", label: "Issue Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "create", dateType: "ontype", name: "issue_date", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.magicDateLabel({ tab: "create", label: "From Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "create", dateType: "ontype", name: "from_date", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.magicDateLabel({ tab: "create", label: "To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "create", dateType: "ontype", name: "to_date", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.displayText({ tab: "create", label: "Instructions", width: "col-sm-2" }),
    ...controls.text({ tab: "create", placeHolder: "Instruction", name: "instruction", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "create", default: true, label: "Active", name: "isActive", width: "col-sm-2" }),


  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Unique",
        accessor: "unique_id",
        show: false
      },
      {
        Header: "GUID",
        accessor: "guid",
        show: false
      },
      {
        Header: "Branch",
        accessor: "branch_display_name",
        width: 150
      },
      {
        Header: "Instruction",
        accessor: "instructions",
        width: 150
      },
      {
        Header: "Account Number",
        accessor: "account_number"
      },
      {
        Header: "Name",
        accessor: "customer_number_display"
      },
      {
        Header: "From Date",
        accessor: "from_date"
      },
      {
        Header: "To Date",
        accessor: "to_date"
      },
      {
        Header: "Instructions",
        accessor: "instructions"
      }
    ]
  }
};

export default ms221;
